"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const react_1 = require("react");
class JsonDebugger extends react_1.Component {
    constructor(props) {
        super(props);
        this.stringifyObject = (object = this.props.object) => {
            const { spaces } = this.props;
            return JSON.stringify(object, null, spaces);
        };
        this.handleChange = (e) => {
            const json = e.target.value;
            this.setState({
                hasError: false,
                json,
            });
            this.updatedFromInside = true;
            try {
                const object = JSON.parse(json);
                this.props.onChange(Object.assign({}, object));
            }
            catch (error) {
                this.setState({ hasError: true });
            }
        };
        this.setFocus = (focused) => () => {
            this.setState({ editionModeEnabled: focused });
        };
        this.state = {
            editionModeEnabled: false,
            hasError: false,
            json: this.stringifyObject(),
        };
    }
    componentDidMount() {
        this.updateTextareaHeight();
    }
    componentWillReceiveProps(nextProps) {
        if (!this.updatedFromInside) {
            const json = this.stringifyObject(nextProps.object);
            this.setState({ json });
        }
    }
    componentDidUpdate() {
        this.updatedFromInside = false;
        this.updateTextareaHeight();
    }
    render() {
        const { editionModeEnabled, hasError } = this.state;
        const value = this.getTextareaValue();
        return (React.createElement("div", { className: classNames('json-debugger', {
                active: editionModeEnabled,
                error: hasError,
            }) },
            hasError && (React.createElement("div", { className: "json-debugger-error" }, "Invalid JSON")),
            React.createElement("textarea", { autoCorrect: "off", autoCapitalize: "off", ref: instance => this.textarea = instance, spellCheck: false, value: value, onBlur: this.setFocus(false), onChange: this.handleChange, onFocus: this.setFocus(true) })));
    }
    getTextareaValue() {
        return this.updatedFromInside
            ? this.state.json
            : this.stringifyObject();
    }
    updateTextareaHeight() {
        this.textarea.style.height = `${this.textarea.scrollHeight}px`;
    }
}
JsonDebugger.defaultProps = {
    spaces: 2,
    onChange: () => { return; },
};
exports.JsonDebugger = JsonDebugger;



//////////////////
// WEBPACK FOOTER
// ./src/components/JsonDebugger/JsonDebugger.tsx
// module id = 357
// module chunks = 0